import { CheckCircle2 } from "lucide-react";
import { Reveal, CtaButton, Highlight, Chevrons } from "./Primitives";
import { SESSION } from "@/config/session";

const ITEMS = [
  "Why saving alone never makes anyone wealthy",
  "What actually creates long-term wealth",
  "How to stop money from leaking every month",
  "Where to focus first for maximum financial impact",
];

export const WhySection = () => (
  <section className="px-4 pb-6 bg-white" data-testid="why-section">
    <Reveal className="max-w-3xl mx-auto rounded-2xl border-2 border-dashed border-green-400 bg-green-50/60 px-5 sm:px-10 pt-8 pb-6 relative">
      <span className="absolute -top-3.5 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-md bg-green-600 text-white text-[11px] sm:text-[12px] font-extrabold uppercase tracking-wide px-3 py-1">
        You'll discover in The Wealth Code
      </span>
      <h2 className="font-black uppercase text-center text-ink text-[21px] sm:text-[28px] leading-tight">
        Why Smart Indians Are <Highlight tone="green">Joining This Masterclass</Highlight>
      </h2>
      <p className="text-center text-[14px] sm:text-[15px] text-zinc-700 mt-4">
        <span className="font-bold text-ink">This is not theory.</span> You'll understand your money live with Sandeep, step by step.
      </p>
      <p className="text-center text-[14px] font-semibold text-ink mt-4">In this masterclass, you will discover:</p>
      <ul className="mt-3 space-y-2.5 max-w-md mx-auto">
        {ITEMS.map((t) => (
          <li key={t} className="flex items-start gap-2.5 text-[14px] text-zinc-800">
            <CheckCircle2 className="w-5 h-5 text-green-600 shrink-0 mt-px" />{t}
          </li>
        ))}
      </ul>
      <div className="mt-6"><CtaButton testId="why-cta-button" /></div>
    </Reveal>
    <Reveal className="max-w-3xl mx-auto mt-4">
      <p data-testid="repeat-banner" className="text-center text-[12.5px] sm:text-sm font-semibold text-ink bg-plum/10 rounded-full px-4 py-2">
        100% FREE Registration • {SESSION.shortLabel} | {SESSION.timeLabel}
      </p>
    </Reveal>
    <Chevrons />
  </section>
);
